import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhLocale from './zh.js'
import enLocale from './en.js'
import { lang } from 'utils/lang'

Vue.use(VueI18n)

const messages = {
  zh: {
    ...zhLocale
  },
  en: {
    ...enLocale
  }
}

export default new VueI18n({
  locale: lang,
  messages
})



// WEBPACK FOOTER //
// ./src/lang/index.js